import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetTierDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TIER_DETAILS, token);
  return res;
};

export const AddTier = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_TIER, payload, token);
  return res;
};

export const DeleteTier = async (TierId) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_TIER + TierId, TierId, token);
  return res;
};

export const UpdateTier = async (TierId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_TIER + TierId, payload, token);
  return res;
};
